import { cn } from "../../../../utils/cn";
import { PaidReceipt } from "../../../../utils/types";
import { LocationIconFilled } from "../PayScreen.icons";
import {
  ReceiptStateCompletedIcon,
  ReceiptStatePendingIcon,
  ReceiptStatePreparingIcon,
} from "./ReceiptState.icons";
import styles from "./ReceiptState.module.scss";
import { useReceiptState } from "./useReceiptState";

export const ReceiptStateV2 = (props: {
  receipt: PaidReceipt;
  isOrdersTab?: boolean;
  barOnly?: boolean;
}) => {
  const { receipt, isOrdersTab = false } = props;

  const {
    addressTo,
    showDeliveryAddress,
    deliveryAddressText,
    firstStepLabel,
    secondStepLabel,
    thirdStepLabel,
    secondStepActive,
    thirdStepActive,
    isDeliveryType,
    isCancelled,
  } = useReceiptState({ isOrdersTab, receipt });

  const lastStepActive = isDeliveryType ? secondStepActive : thirdStepActive;

  return (
    <div className={`${styles.receipt_status} ${styles.is_orders_tab}`}>
      {showDeliveryAddress && isOrdersTab && (
        <p
          data-testid="delivery-to-address"
          className={styles.delivery_section}
        >
          {addressTo}
          <span>
            <LocationIconFilled size={12} />
            {deliveryAddressText}
          </span>
        </p>
      )}
      {!isCancelled && (
        <div className={styles.state_wrapper_v2}>
          <div
            className={`${styles.state_wrapper_v2__line} ${styles["state_wrapper_v2__line--leading"]} ${styles.active}`}
          />
          <div className={`${styles.state_wrapper_v2__state} ${styles.active}`}>
            <span className={styles.state_wrapper_v2__state__icon}>
              <ReceiptStatePendingIcon size={19.5} />
            </span>
            <span
              data-testId="recieved-state"
              className={styles.state_wrapper_v2__state__text}
            >
              {firstStepLabel}
            </span>
          </div>
          <div
            className={`${styles.state_wrapper_v2__line}${
              secondStepActive ? ` ${styles.active}` : ""
            }`}
          />
          <div
            className={`${styles.state_wrapper_v2__state}${
              secondStepActive ? ` ${styles.active}` : ""
            }`}
          >
            <span className={styles.state_wrapper_v2__state__icon}>
              <ReceiptStatePreparingIcon width={24} height={16} />
            </span>
            <span
              data-testId="confirmed-state"
              className={styles.state_wrapper_v2__state__text}
            >
              {secondStepLabel}
            </span>
          </div>

          {!isDeliveryType && (
            <>
              <div
                className={`${styles.state_wrapper_v2__line}${
                  thirdStepActive ? ` ${styles.active}` : ""
                }`}
              />
              <div
                className={`${styles.state_wrapper_v2__state}${
                  thirdStepActive ? ` ${styles.active}` : ""
                }`}
              >
                <span className={styles.state_wrapper_v2__state__icon}>
                  <ReceiptStateCompletedIcon size={21} />
                </span>
                <span className={styles.state_wrapper_v2__state__text}>
                  {thirdStepLabel}
                </span>
              </div>
            </>
          )}

          <div
            className={cn(
              styles.state_wrapper_v2__line,
              styles["state_wrapper_v2__line--trailing"],
              lastStepActive && styles.active
            )}
          />
        </div>
      )}
    </div>
  );
};
